import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";
import { LanguageService } from "./language.service";

@Injectable()
export class RecoverPasswordService 
{
        constructor
        (
                public _api: ApiService, 
                public language: LanguageService,
                public _cache: CacheService,
                private mappings: Mappings
        ) {}

        recoverPasswordRequest(email: string) 
        {
                email = email.toLowerCase();
                let lang = this.language.getLongLang();

                return this._api.post(this.mappings.Web_Api_Recover_Password, { Email: email, Lang: lang })
                        .do(result => result)
                        .share();
        }

        getRecoverPasswordData(lang: string) 
        {
                let url = this.mappings.Web_Api_Get_Recover_Password_Data.replace('{lang}', lang);

                return this._api.get(url);
        }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/recover-password.service.ts